var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20.75 12a8.75 8.75 0 1 0-17.5 0 8.75 8.75 0 0 0 17.5 0m-10-6a1.25 1.25 0 1 1 2.5 0v5.227l3.309 1.655.112.063a1.25 1.25 0 0 1-1.112 2.224l-.118-.05-4-2A1.25 1.25 0 0 1 10.75 12zm12.5 6c0 6.213-5.037 11.25-11.25 11.25S.75 18.213.75 12 5.787.75 12 .75 23.25 5.787 23.25 12"
  })));
};
export default SvgClock;